import { VideoSummaryFragment } from "@graphql/generated/graphql";
import Link from "next/link";
import Image from "next/image";

interface IShortsCardProps {
  short: VideoSummaryFragment;
}

const ShortsCard: React.FC<IShortsCardProps> = ({
  short: { id, imageUrl, title },
}) => {
  return (
    <div className="group rounded-lg transition-shadow duration-300 hover:cursor-pointer hover:shadow-custom">
      <Link href={`/shorts/${id}`} passHref>
        <div className="relative flex flex-col items-start">
          <div className="aspect-w-9 aspect-h-16 relative w-full">
            <Image
              className="rounded-lg"
              src={imageUrl}
              alt={title}
              layout="fill"
              objectFit="cover"
            />
          </div>
          <p className="my-4 mx-2 overflow-ellipsis font-sen text-sm font-bold leading-[16px] text-text-darkest line-clamp-3 group-hover:text-text-dark md:text-sm">
            {title}
          </p>
        </div>
      </Link>
    </div>
  );
};

export default ShortsCard;
